import "./LoginDashboardDrawer.css";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { getCurrentlyLoggedInUser, logoutUser } from "../CommonFunctions";
import { useEffect, useState } from "react";

interface Props {
  onClose?: () => void;
}

const LoginDashboardDrawer = ({ onClose }: Props): JSX.Element => {
  const frontendSigninUrl = "/login";
  const dashboardURL = "/dashboard/user";
  const theme = useTheme();
  const navigate = useNavigate();
  const [displayText, setDisplayText] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentlyLoggedInUser();
        setDisplayText(`Hello, ${user.first_name}`);
        setLoggedIn(true);
      } catch (error) {
        setDisplayText("Log in/Sign in");
        setLoggedIn(false);
      }
    };
    fetchUser();
  }, []);

  const toggleDrawer = () => {
    if (loggedIn) {
      setIsDrawerOpen((prev) => !prev);
    } else {
      navigate(frontendSigninUrl);
      if (onClose) onClose();
    }
  };

  const handleNavigateDashboard = () => {
    navigate(dashboardURL);
    closeDrawer();
  };

  const handleLogout = () => {
    setLoggedIn(false);
    setDisplayText("Log in/Sign in");
    logoutUser();
    closeDrawer();
    navigate(frontendSigninUrl);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    if (onClose) onClose();
  };

  return (
    <div>
      <Button
        component="a"
        color="primary"
        onClick={toggleDrawer}
        variant="text"
        sx={{
          color: theme.palette.text.primary,
          mx: 1.5,
          marginLeft: "15px",
          "&:active, &:hover": {
            color:
              theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : theme.palette.success.dark,
          },
        }}
      >
        {displayText}
      </Button>

      {/* Overlay */}
      <div
        className={`login-dashboard-overlay ${isDrawerOpen ? "active" : ""}`}
        onClick={closeDrawer}
      ></div>

      {/* Drawer Menu */}
      <div
        className={`login-dashboard-drawer-menu ${
          isDrawerOpen ? "active" : ""
        }`}
      >
        <div className="login-dashboard-menu-header">
          <span>{displayText}</span>
          <button
            onClick={closeDrawer}
            className="login-dashboard-close-drawer-btn"
          >
            X
          </button>
        </div>

        <div className="login-dashboard-menu-options">
          <button
            onClick={handleNavigateDashboard}
            className="login-dashboard-menu-item"
          >
            Dashboard
          </button>
          <button
            onClick={handleLogout}
            className="login-dashboard-menu-item"
            style={{ marginTop: "1.2vh" }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginDashboardDrawer;
